import {RECOVERY_INVITES} from '../actionTypes'
import {reducerFactory} from '../../lib/asyncUtil'

export default reducerFactory(RECOVERY_INVITES)
